import { GroupChannelProvider } from '@sendbird/uikit-react/GroupChannel/context';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectChannelUrl } from '_store/chat/selector';

import CustomSearchPannelView from './CustomSearchPannelView';

const CustomSearchPannel = () => {
  const channelUrl = useSelector(selectChannelUrl);

  return (
    <GroupChannelProvider channelUrl={channelUrl}>
      <CustomSearchPannelView />
    </GroupChannelProvider>
  );
};

export default CustomSearchPannel;
